import moment from "moment";
import "moment/locale/sv";

const holidays = [
  "20190622",
  "20191102",
  "20191225",
  "20191226",
  "20200101",
  "20200106",
  "20200410",
  "20200412",
  "20200413",
  "20200501",
  "20200521",
  "20200531",
  "20200606",
  "20200620",
  "20201031",
  "20201225",
  "20201226",
  "20210101",
  "20210106",
  "20210402",
  "20210404",
  "20210405",
  "20210501",
  "20210513",
  "20210523",
  "20210606",
  "20210626",
  "20211106",
  "20211225",
  "20211226",
  "20220101",
  "20220106",
  "20220415",
  "20220417",
  "20220418",
  "20220501",
  "20220526",
  "20220605",
  "20220606",
  "20220625",
  "20221105",
  "20221225",
  "20221226",
  "20230101",
  "20230106",
  "20230407",
  "20230409",
  "20230410",
  "20230501",
  "20230518",
  "20230528",
  "20230606",
  "20230624",
  "20231104",
  "20231225",
  "20231226",
];

const getDate = (day, week, year) => {
  return moment()
    .locale("sv")
    .year(year)
    .isoWeek(week)
    .isoWeekday(day)
    .hour(0)
    .minute(0)
    .second(0)
    .milliseconds(0)
    .toISOString();
};

export const getDays = (week, occasionDates) => {
  const days = [1, 2, 3, 4, 5, 6, 7];
  let dates = [];
  const { thisWeek, thisYear } = week;
  const getDay = (day) => {
    const date = getDate(day, thisWeek, thisYear);
    return {
      day,
      date,
      hasOccasions: occasionDates.includes(moment(date).format("YYYYMMDD")),
      isHoliday:
        day === 7 || holidays.includes(moment(date).format("YYYYMMDD")),
      isToday: moment(date).format("YYYYMMDD") === moment().format("YYYYMMDD"),
      value: moment(date).format("dddd"),
    };
  };
  days.forEach((d) => {
    dates = [...dates, getDay(d)];
  });
  return dates;
};
